<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    activeValue: {
      get() {
        return this.modelValue
      },
      set(activeValue: string) {
        this.$emit('update:modelValue', activeValue)
      },
    },
  },
})
</script>

<template>
  <div class="flex items-center">
    <div class="flex items-center">
      <label class="inline-flex cursor-pointer items-center">
        <input
          v-model="activeValue"
          type="radio"
          :name="name"
          :value="value"
          class="peer sr-only"
          :disabled
        />
        <div
          class="size-6 rounded-full border border-slate-300 bg-pure-white peer-checked:border-4 peer-checked:border-neutral-300 peer-checked:bg-black"
        />
        <slot />
      </label>
    </div>
  </div>
</template>
